import { useOrderMovements } from '@/api/useOrderMovements'
import type { components } from '@/types/api/v1'
import { DeleteOutlined } from '@ant-design/icons'
import { GraviButton } from '@gravitate-js/excalibrr'
import type { ICellRendererParams } from 'ag-grid-community'
import { Popconfirm } from 'antd'
import { useCallback } from 'react'

export function DeleteEbolButton<T extends components['schemas']['EBolResponse']>({
  data,
}: ICellRendererParams<T, unknown, unknown>) {
  const { useRemoveEbol } = useOrderMovements()
  const { mutate } = useRemoveEbol()
  const remove = useCallback(
    () => data?._id && mutate({ params: { query: { ebol_id: data._id } } }),
    [mutate, data?._id]
  )
  return (
    <Popconfirm title='Delete eBOL' description='Are you sure you want to delete this eBOL?' onConfirm={remove}>
      <GraviButton icon={<DeleteOutlined />} />
    </Popconfirm>
  )
}
